export default __webpack_public_path__ + "static/dashboard.pt-49828b5f6c1bd016778eb65b5f4fbf76.svg";